import React, { useContext, useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import moment from 'moment';
import EventsListModal from '../../EventsList/modal'
import { arrayForSelect } from '../../../utils/arrayForSelect';
import { useDispatch, useSelector } from 'react-redux';
import { getSchoolYears } from '../../../actions/common';
import { getEventById } from '../../../actions/events_list';
import CustomSelect from '../../../components/CustomSelect';
import { getEventsStudentList } from '../../../actions/students/eventsStudent';


export default function Events() {

  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)

  const { values, setValues } = allForms

  const { events: eventsData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)
  const { schoolYears } = useSelector(state => state.common)
  const { eventInfo } = useSelector(state => state.events_list)
  const [year, setYear] = useState(null)

  // useEffect(() => {
  //   !year && dispatch(getSchoolYears())
  //   year && studentId && dispatch(getEventsStudentList({ xp_key: year, mid: studentId }))
  // }, [year, studentId, dispatch])

  useEffect(() => {
    const dataJson = JSON.stringify(eventsData)
    if (!addMode && eventsData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      // ВРЕМЕННО (2026-06-23): backend отдаёт мероприятия сгруппированными по
      // направлениям ({ edid, name, events: [...] }). Вкладка «Мероприятия»
      // показывает только нижний уровень (сами мероприятия) единым списком,
      // как и раньше — расплёскиваем группы в плоский массив. Убрать flatMap,
      // если backend начнёт отдавать плоский список сразу.
      const flatEvents = Array.isArray(eventsData)
        ? eventsData.flatMap(group => (Array.isArray(group.events) ? group.events : []))
        : []
      setValues(prev => ({
        ...prev,
        events: flatEvents
      }))
      if (updateInitialValues) {
        updateInitialValues('events', flatEvents)
      }
    }
  }, [eventsData, addMode, setValues, updateInitialValues])

  const handleYearChange = (name, value) => {
    setYear(value)
  }

  const openModal = (data) => () => {
    if (data && data !== 'add' && data.nid) {
      dispatch(getEventById(data.nid))
    }
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const renderLi = (item) => {
    const { nid, event_date, fullname, comment, total_ball, achievement_name, news_level_text } = item
    return (
      <tr key={nid} onClick={openModal(item)}>
        <td>{event_date ? moment(event_date).format('DD.MM.YYYY') : ''}</td>
        <td>{news_level_text || ''}</td>
        <td>{fullname || ''}</td>
        <td>{comment || ''}</td>
        <td>{total_ball || ''}</td>
        <td>{achievement_name || ''}</td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem !== null &&
        <EventsListModal
          event={selectedItem?.nid ? eventInfo : null}
          isOpen={!!selectedItem}
          closeModal={closeModal}
          filters={{}}
        />
      }

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Учебный год'
            valuesName="year"
            options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
            width='120px'
            value={year}
            setFieldValue={handleYearChange}
          />
        </div>
        <Table className={styles.table} >
          <thead>
            <tr>
              <th>Дата</th>
              <th>Уровень мероприятия</th>
              <th>Название мероприятия/Форма мероприятия</th>
              <th>Достижения</th>
              <th>Баллы</th>
              <th>Результаты</th>
            </tr>
          </thead>
          <tbody>
            {values.events?.map(renderLi)}
          </tbody>
        </Table>
        <br />
        <Button onClick={openModal('add')}>Добавить</Button>
      </div>
    </div>
  )
}

